import NavBar from './navBar';
import '../styles/layout.css';

function Layout({ children }) {
    return (
        <div>
            <NavBar />
            {children}
        </div>
    );
}

export default Layout;
